// extracted by mini-css-extract-plugin
export default {"container":"Summary--container--NdA-G"};